<template>
      <v-dialog
      v-model="showForm"
      persistent
      width="600"
      class="participants mx-auto overflow-hidden"
    >
    <v-card
      class="d-flex flex-row mx-auto overflow-hidden"
      flat
      width="600"
      tile
    >
      <v-card width="600">
        <v-card-title class="text-h5">
          <span class="participants-title" v-html="$t('videoconf.aboutDialog.title', { name: videoConference.name })"></span>
        </v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"> {{ $t('videoconf.info.info') }} </th>
                <th class="text-left"> {{ $t('videoconf.info.value') }} </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in infos" :key="item.name" v-show="!!item.value">
                <td>{{ $t(item.name) }}</td>
                <td>{{ item.value }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card max-height="600px" style="overflow-y: scroll" elevation="0">
        </v-card>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="$emit('close')"
          >
            {{ $t('videoconf.aboutDialog.btn.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import VideoConference from 'Store/class/video_conference'

export default {
  name: 'video-conference-about-dialog',
  props: {
    showForm: { type: Boolean, default: false },
    videoConference: { type: VideoConference, default () { return new VideoConference() } }
  },
  computed: {
    ...mapGetters({
      users: 'users/listAll'
    }),
    phoneNumbers () { return this.videoConference.phone_numbers.join(', ') },
    infos () {
      return [
        { name: 'videoconf.info.items.admins_count', value: this.videoConference.adminsId.length },
        { name: 'videoconf.info.items.users_count', value: this.videoConference.usersId.length },
        { name: 'videoconf.info.items.guest_url', value: this.videoConference.guestURL },
        { name: 'videoconf.info.items.expireAt', value: this.videoConference.expireAt.toLocaleString(this.$i18n.locale, {}) },
        { name: 'videoconf.info.items.extension', value: this.videoConference.username },
        { name: 'videoconf.info.items.phone_numbers', value: this.phoneNumbers },
        { name: 'videoconf.info.items.roomNumber', value: this.phoneNumbers ? this.videoConference.roomNumber : null },
        { name: 'videoconf.info.items.roomPin', value: this.phoneNumbers ? this.videoConference.roomPin : null },
        { name: 'videoconf.info.items.sharedScreenAdmin', value: this.$t(`videoconf.info.items.enabled.${this.videoConference.sharedScreenAdmin}`) },
        { name: 'videoconf.info.items.sharedScreenGuest', value: this.$t(`videoconf.info.items.enabled.${this.videoConference.sharedScreenGuest}`) },
        { name: 'videoconf.info.items.recordingAdmin', value: this.$t(`videoconf.info.items.enabled.${this.videoConference.recordingAdmin}`) },
        { name: 'videoconf.info.items.recordingGuest', value: this.$t(`videoconf.info.items.enabled.${this.videoConference.recordingGuest}`) }
      ]
    }
  },
  methods: {
  }
}
</script>

<style>
</style>
